import { createContext, useContext } from 'react';
import type { BreadcrumbItem } from './breadcrumbsTypes';

type BreadcrumbsContextValue = {
  items: BreadcrumbItem[];
  visible: boolean;
  setOverrideItems: (items: BreadcrumbItem[] | null) => void;
  setOverrideVisible: (visible: boolean | null) => void;
  clearOverride: () => void;
};

export const BreadcrumbsContext = createContext<BreadcrumbsContextValue>({
  items: [],
  visible: false,
  setOverrideItems: () => undefined,
  setOverrideVisible: () => undefined,
  clearOverride: () => undefined,
});

export const useBreadcrumbs = (): BreadcrumbsContextValue => useContext(BreadcrumbsContext);
